// source: acompanha/jobs/v1/jobs.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global =
    (typeof globalThis !== 'undefined' && globalThis) ||
    (typeof window !== 'undefined' && window) ||
    (typeof global !== 'undefined' && global) ||
    (typeof self !== 'undefined' && self) ||
    (function () { return this; }).call(null) ||
    Function('return this')();

var acompanha_common_v1_common_pb = require('../../../acompanha/common/v1/common_pb.js');
goog.object.extend(proto, acompanha_common_v1_common_pb);
var acompanha_printers_v1_printers_pb = require('../../../acompanha/printers/v1/printers_pb.js');
goog.object.extend(proto, acompanha_printers_v1_printers_pb);
var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js');
goog.object.extend(proto, google_protobuf_timestamp_pb);
goog.exportSymbol('proto.acompanha.jobs.v1.CreateJobRequest', null, global);
goog.exportSymbol('proto.acompanha.jobs.v1.CreateJobResponse', null, global);
goog.exportSymbol('proto.acompanha.jobs.v1.DeleteJobRequest', null, global);
goog.exportSymbol('proto.acompanha.jobs.v1.GetJobRequest', null, global);
goog.exportSymbol('proto.acompanha.jobs.v1.GetJobResponse', null, global);
goog.exportSymbol('proto.acompanha.jobs.v1.Job', null, global);
goog.exportSymbol('proto.acompanha.jobs.v1.JobFilament', null, global);
goog.exportSymbol('proto.acompanha.jobs.v1.ListJobsByPrinterRequest', null, global);
goog.exportSymbol('proto.acompanha.jobs.v1.ListJobsRequest', null, global);
goog.exportSymbol('proto.acompanha.jobs.v1.ListJobsResponse', null, global);
goog.exportSymbol('proto.acompanha.jobs.v1.PrinterStat', null, global);
goog.exportSymbol('proto.acompanha.jobs.v1.PrinterStatsRequest', null, global);
goog.exportSymbol('proto.acompanha.jobs.v1.PrinterStatsResponse', null, global);
goog.exportSymbol('proto.acompanha.jobs.v1.UpdateJobRequest', null, global);
goog.exportSymbol('proto.acompanha.jobs.v1.UpdateJobResponse', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.jobs.v1.JobFilament = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.acompanha.jobs.v1.JobFilament, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.jobs.v1.JobFilament.displayName = 'proto.acompanha.jobs.v1.JobFilament';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.jobs.v1.Job = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.acompanha.jobs.v1.Job.repeatedFields_, null);
};
goog.inherits(proto.acompanha.jobs.v1.Job, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.jobs.v1.Job.displayName = 'proto.acompanha.jobs.v1.Job';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.jobs.v1.PrinterStat = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.acompanha.jobs.v1.PrinterStat.repeatedFields_, null);
};
goog.inherits(proto.acompanha.jobs.v1.PrinterStat, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.jobs.v1.PrinterStat.displayName = 'proto.acompanha.jobs.v1.PrinterStat';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.jobs.v1.ListJobsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.acompanha.jobs.v1.ListJobsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.jobs.v1.ListJobsRequest.displayName = 'proto.acompanha.jobs.v1.ListJobsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.jobs.v1.ListJobsByPrinterRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.acompanha.jobs.v1.ListJobsByPrinterRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.jobs.v1.ListJobsByPrinterRequest.displayName = 'proto.acompanha.jobs.v1.ListJobsByPrinterRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.jobs.v1.ListJobsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.acompanha.jobs.v1.ListJobsResponse.repeatedFields_, null);
};
goog.inherits(proto.acompanha.jobs.v1.ListJobsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.jobs.v1.ListJobsResponse.displayName = 'proto.acompanha.jobs.v1.ListJobsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.jobs.v1.GetJobRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.acompanha.jobs.v1.GetJobRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.jobs.v1.GetJobRequest.displayName = 'proto.acompanha.jobs.v1.GetJobRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.jobs.v1.GetJobResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.acompanha.jobs.v1.GetJobResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.jobs.v1.GetJobResponse.displayName = 'proto.acompanha.jobs.v1.GetJobResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.jobs.v1.CreateJobRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.acompanha.jobs.v1.CreateJobRequest.repeatedFields_, null);
};
goog.inherits(proto.acompanha.jobs.v1.CreateJobRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.jobs.v1.CreateJobRequest.displayName = 'proto.acompanha.jobs.v1.CreateJobRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.jobs.v1.CreateJobResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.acompanha.jobs.v1.CreateJobResponse.repeatedFields_, null);
};
goog.inherits(proto.acompanha.jobs.v1.CreateJobResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.jobs.v1.CreateJobResponse.displayName = 'proto.acompanha.jobs.v1.CreateJobResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.jobs.v1.UpdateJobRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.acompanha.jobs.v1.UpdateJobRequest.repeatedFields_, null);
};
goog.inherits(proto.acompanha.jobs.v1.UpdateJobRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.jobs.v1.UpdateJobRequest.displayName = 'proto.acompanha.jobs.v1.UpdateJobRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.jobs.v1.UpdateJobResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.acompanha.jobs.v1.UpdateJobResponse.repeatedFields_, null);
};
goog.inherits(proto.acompanha.jobs.v1.UpdateJobResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.jobs.v1.UpdateJobResponse.displayName = 'proto.acompanha.jobs.v1.UpdateJobResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.jobs.v1.DeleteJobRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.acompanha.jobs.v1.DeleteJobRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.jobs.v1.DeleteJobRequest.displayName = 'proto.acompanha.jobs.v1.DeleteJobRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.jobs.v1.PrinterStatsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.acompanha.jobs.v1.PrinterStatsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.jobs.v1.PrinterStatsRequest.displayName = 'proto.acompanha.jobs.v1.PrinterStatsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.jobs.v1.PrinterStatsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.acompanha.jobs.v1.PrinterStatsResponse.repeatedFields_, null);
};
goog.inherits(proto.acompanha.jobs.v1.PrinterStatsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.jobs.v1.PrinterStatsResponse.displayName = 'proto.acompanha.jobs.v1.PrinterStatsResponse';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.jobs.v1.JobFilament.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.jobs.v1.JobFilament.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.jobs.v1.JobFilament} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.jobs.v1.JobFilament.toObject = function(includeInstance, msg) {
  var f, obj = {
color: jspb.Message.getFieldWithDefault(msg, 1, ""),
filamentUuid: jspb.Message.getFieldWithDefault(msg, 2, ""),
grams: jspb.Message.getFieldWithDefault(msg, 3, 0),
colorLabel: jspb.Message.getFieldWithDefault(msg, 4, ""),
type: jspb.Message.getFieldWithDefault(msg, 5, ""),
brand: jspb.Message.getFieldWithDefault(msg, 6, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.jobs.v1.JobFilament}
 */
proto.acompanha.jobs.v1.JobFilament.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.jobs.v1.JobFilament;
  return proto.acompanha.jobs.v1.JobFilament.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.jobs.v1.JobFilament} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.jobs.v1.JobFilament}
 */
proto.acompanha.jobs.v1.JobFilament.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setColor(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setFilamentUuid(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setGrams(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setColorLabel(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setType(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setBrand(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.jobs.v1.JobFilament.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.jobs.v1.JobFilament.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.jobs.v1.JobFilament} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.jobs.v1.JobFilament.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getColor();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getFilamentUuid();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getGrams();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getColorLabel();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getType();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getBrand();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
};


/**
 * optional string color = 1;
 * @return {string}
 */
proto.acompanha.jobs.v1.JobFilament.prototype.getColor = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.jobs.v1.JobFilament} returns this
 */
proto.acompanha.jobs.v1.JobFilament.prototype.setColor = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string filament_uuid = 2;
 * @return {string}
 */
proto.acompanha.jobs.v1.JobFilament.prototype.getFilamentUuid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.jobs.v1.JobFilament} returns this
 */
proto.acompanha.jobs.v1.JobFilament.prototype.setFilamentUuid = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional int32 grams = 3;
 * @return {number}
 */
proto.acompanha.jobs.v1.JobFilament.prototype.getGrams = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.acompanha.jobs.v1.JobFilament} returns this
 */
proto.acompanha.jobs.v1.JobFilament.prototype.setGrams = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional string color_label = 4;
 * @return {string}
 */
proto.acompanha.jobs.v1.JobFilament.prototype.getColorLabel = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.jobs.v1.JobFilament} returns this
 */
proto.acompanha.jobs.v1.JobFilament.prototype.setColorLabel = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string type = 5;
 * @return {string}
 */
proto.acompanha.jobs.v1.JobFilament.prototype.getType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.jobs.v1.JobFilament} returns this
 */
proto.acompanha.jobs.v1.JobFilament.prototype.setType = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string brand = 6;
 * @return {string}
 */
proto.acompanha.jobs.v1.JobFilament.prototype.getBrand = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.jobs.v1.JobFilament} returns this
 */
proto.acompanha.jobs.v1.JobFilament.prototype.setBrand = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.acompanha.jobs.v1.Job.repeatedFields_ = [15];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.jobs.v1.Job.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.jobs.v1.Job.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.jobs.v1.Job} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.jobs.v1.Job.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, ""),
uuid: jspb.Message.getFieldWithDefault(msg, 2, ""),
printerUuid: jspb.Message.getFieldWithDefault(msg, 3, ""),
jobId: jspb.Message.getFieldWithDefault(msg, 4, ""),
fileName: jspb.Message.getFieldWithDefault(msg, 5, ""),
estimatedDurationMinutes: jspb.Message.getFieldWithDefault(msg, 6, 0),
estimatedFilamentConsumptionGrams: jspb.Message.getFieldWithDefault(msg, 7, 0),
startedAt: (f = msg.getStartedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
finishedAt: (f = msg.getFinishedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
status: jspb.Message.getFieldWithDefault(msg, 10, ""),
statusReason: jspb.Message.getFieldWithDefault(msg, 11, ""),
objectCount: jspb.Message.getFieldWithDefault(msg, 12, 0),
printedCount: jspb.Message.getFieldWithDefault(msg, 13, 0),
successPercent: jspb.Message.getFloatingPointFieldWithDefault(msg, 14, 0.0),
filamentsList: jspb.Message.toObjectList(msg.getFilamentsList(),
    proto.acompanha.jobs.v1.JobFilament.toObject, includeInstance),
metadataJson: jspb.Message.getFieldWithDefault(msg, 16, ""),
createdAt: (f = msg.getCreatedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
updatedAt: (f = msg.getUpdatedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
actualFilamentConsumptionGrams: (f = jspb.Message.getField(msg, 19)) == null ? undefined : f,
filamentPending: jspb.Message.getBooleanFieldWithDefault(msg, 20, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.jobs.v1.Job}
 */
proto.acompanha.jobs.v1.Job.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.jobs.v1.Job;
  return proto.acompanha.jobs.v1.Job.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.jobs.v1.Job} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.jobs.v1.Job}
 */
proto.acompanha.jobs.v1.Job.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setUuid(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setPrinterUuid(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setJobId(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setFileName(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setEstimatedDurationMinutes(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setEstimatedFilamentConsumptionGrams(value);
      break;
    case 8:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setStartedAt(value);
      break;
    case 9:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setFinishedAt(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setStatus(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setStatusReason(value);
      break;
    case 12:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setObjectCount(value);
      break;
    case 13:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPrintedCount(value);
      break;
    case 14:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setSuccessPercent(value);
      break;
    case 15:
      var value = new proto.acompanha.jobs.v1.JobFilament;
      reader.readMessage(value,proto.acompanha.jobs.v1.JobFilament.deserializeBinaryFromReader);
      msg.addFilaments(value);
      break;
    case 16:
      var value = /** @type {string} */ (reader.readString());
      msg.setMetadataJson(value);
      break;
    case 17:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setCreatedAt(value);
      break;
    case 18:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setUpdatedAt(value);
      break;
    case 19:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setActualFilamentConsumptionGrams(value);
      break;
    case 20:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setFilamentPending(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.jobs.v1.Job.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.jobs.v1.Job.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.jobs.v1.Job} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.jobs.v1.Job.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getUuid();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getPrinterUuid();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getJobId();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getFileName();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getEstimatedDurationMinutes();
  if (f !== 0) {
    writer.writeInt32(
      6,
      f
    );
  }
  f = message.getEstimatedFilamentConsumptionGrams();
  if (f !== 0) {
    writer.writeInt32(
      7,
      f
    );
  }
  f = message.getStartedAt();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getFinishedAt();
  if (f != null) {
    writer.writeMessage(
      9,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getStatus();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getStatusReason();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
  f = message.getObjectCount();
  if (f !== 0) {
    writer.writeInt32(
      12,
      f
    );
  }
  f = message.getPrintedCount();
  if (f !== 0) {
    writer.writeInt32(
      13,
      f
    );
  }
  f = message.getSuccessPercent();
  if (f !== 0.0) {
    writer.writeDouble(
      14,
      f
    );
  }
  f = message.getFilamentsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      15,
      f,
      proto.acompanha.jobs.v1.JobFilament.serializeBinaryToWriter
    );
  }
  f = message.getMetadataJson();
  if (f.length > 0) {
    writer.writeString(
      16,
      f
    );
  }
  f = message.getCreatedAt();
  if (f != null) {
    writer.writeMessage(
      17,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getUpdatedAt();
  if (f != null) {
    writer.writeMessage(
      18,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 19));
  if (f != null) {
    writer.writeInt32(
      19,
      f
    );
  }
  f = message.getFilamentPending();
  if (f) {
    writer.writeBool(
      20,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.acompanha.jobs.v1.Job.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.jobs.v1.Job} returns this
 */
proto.acompanha.jobs.v1.Job.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string uuid = 2;
 * @return {string}
 */
proto.acompanha.jobs.v1.Job.prototype.getUuid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.jobs.v1.Job} returns this
 */
proto.acompanha.jobs.v1.Job.prototype.setUuid = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string printer_uuid = 3;
 * @return {string}
 */
proto.acompanha.jobs.v1.Job.prototype.getPrinterUuid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.jobs.v1.Job} returns this
 */
proto.acompanha.jobs.v1.Job.prototype.setPrinterUuid = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string job_id = 4;
 * @return {string}
 */
proto.acompanha.jobs.v1.Job.prototype.getJobId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.jobs.v1.Job} returns this
 */
proto.acompanha.jobs.v1.Job.prototype.setJobId = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string file_name = 5;
 * @return {string}
 */
proto.acompanha.jobs.v1.Job.prototype.getFileName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.jobs.v1.Job} returns this
 */
proto.acompanha.jobs.v1.Job.prototype.setFileName = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional int32 estimated_duration_minutes = 6;
 * @return {number}
 */
proto.acompanha.jobs.v1.Job.prototype.getEstimatedDurationMinutes = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.acompanha.jobs.v1.Job} returns this
 */
proto.acompanha.jobs.v1.Job.prototype.setEstimatedDurationMinutes = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional int32 estimated_filament_consumption_grams = 7;
 * @return {number}
 */
proto.acompanha.jobs.v1.Job.prototype.getEstimatedFilamentConsumptionGrams = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.acompanha.jobs.v1.Job} returns this
 */
proto.acompanha.jobs.v1.Job.prototype.setEstimatedFilamentConsumptionGrams = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};


/**
 * optional google.protobuf.Timestamp started_at = 8;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.acompanha.jobs.v1.Job.prototype.getStartedAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 8));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.acompanha.jobs.v1.Job} returns this
*/
proto.acompanha.jobs.v1.Job.prototype.setStartedAt = function(value) {
  return jspb.Message.setWrapperField(this, 8, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.acompanha.jobs.v1.Job} returns this
 */
proto.acompanha.jobs.v1.Job.prototype.clearStartedAt = function() {
  return this.setStartedAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.acompanha.jobs.v1.Job.prototype.hasStartedAt = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional google.protobuf.Timestamp finished_at = 9;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.acompanha.jobs.v1.Job.prototype.getFinishedAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 9));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.acompanha.jobs.v1.Job} returns this
*/
proto.acompanha.jobs.v1.Job.prototype.setFinishedAt = function(value) {
  return jspb.Message.setWrapperField(this, 9, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.acompanha.jobs.v1.Job} returns this
 */
proto.acompanha.jobs.v1.Job.prototype.clearFinishedAt = function() {
  return this.setFinishedAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.acompanha.jobs.v1.Job.prototype.hasFinishedAt = function() {
  return jspb.Message.getField(this, 9) != null;
};


/**
 * optional string status = 10;
 * @return {string}
 */
proto.acompanha.jobs.v1.Job.prototype.getStatus = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.jobs.v1.Job} returns this
 */
proto.acompanha.jobs.v1.Job.prototype.setStatus = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * optional string status_reason = 11;
 * @return {string}
 */
proto.acompanha.jobs.v1.Job.prototype.getStatusReason = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.jobs.v1.Job} returns this
 */
proto.acompanha.jobs.v1.Job.prototype.setStatusReason = function(value) {
  return jspb.Message.setProto3StringField(this, 11, value);
};


/**
 * optional int32 object_count = 12;
 * @return {number}
 */
proto.acompanha.jobs.v1.Job.prototype.getObjectCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 12, 0));
};


/**
 * @param {number} value
 * @return {!proto.acompanha.jobs.v1.Job} returns this
 */
proto.acompanha.jobs.v1.Job.prototype.setObjectCount = function(value) {
  return jspb.Message.setProto3IntField(this, 12, value);
};


/**
 * optional int32 printed_count = 13;
 * @return {number}
 */
proto.acompanha.jobs.v1.Job.prototype.getPrintedCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 13, 0));
};


/**
 * @param {number} value
 * @return {!proto.acompanha.jobs.v1.Job} returns this
 */
proto.acompanha.jobs.v1.Job.prototype.setPrintedCount = function(value) {
  return jspb.Message.setProto3IntField(this, 13, value);
};


/**
 * optional double success_percent = 14;
 * @return {number}
 */
proto.acompanha.jobs.v1.Job.prototype.getSuccessPercent = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 14, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.acompanha.jobs.v1.Job} returns this
 */
proto.acompanha.jobs.v1.Job.prototype.setSuccessPercent = function(value) {
  return jspb.Message.setProto3FloatField(this, 14, value);
};


/**
 * repeated JobFilament filaments = 15;
 * @return {!Array<!proto.acompanha.jobs.v1.JobFilament>}
 */
proto.acompanha.jobs.v1.Job.prototype.getFilamentsList = function() {
  return /** @type{!Array<!proto.acompanha.jobs.v1.JobFilament>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.acompanha.jobs.v1.JobFilament, 15));
};


/**
 * @param {!Array<!proto.acompanha.jobs.v1.JobFilament>} value
 * @return {!proto.acompanha.jobs.v1.Job} returns this
*/
proto.acompanha.jobs.v1.Job.prototype.setFilamentsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 15, value);
};


/**
 * @param {!proto.acompanha.jobs.v1.JobFilament=} opt_value
 * @param {number=} opt_index
 * @return {!proto.acompanha.jobs.v1.JobFilament}
 */
proto.acompanha.jobs.v1.Job.prototype.addFilaments = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 15, opt_value, proto.acompanha.jobs.v1.JobFilament, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.acompanha.jobs.v1.Job} returns this
 */
proto.acompanha.jobs.v1.Job.prototype.clearFilamentsList = function() {
  return this.setFilamentsList([]);
};


/**
 * optional string metadata_json = 16;
 * @return {string}
 */
proto.acompanha.jobs.v1.Job.prototype.getMetadataJson = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 16, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.jobs.v1.Job} returns this
 */
proto.acompanha.jobs.v1.Job.prototype.setMetadataJson = function(value) {
  return jspb.Message.setProto3StringField(this, 16, value);
};


/**
 * optional google.protobuf.Timestamp created_at = 17;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.acompanha.jobs.v1.Job.prototype.getCreatedAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 17));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.acompanha.jobs.v1.Job} returns this
*/
proto.acompanha.jobs.v1.Job.prototype.setCreatedAt = function(value) {
  return jspb.Message.setWrapperField(this, 17, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.acompanha.jobs.v1.Job} returns this
 */
proto.acompanha.jobs.v1.Job.prototype.clearCreatedAt = function() {
  return this.setCreatedAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.acompanha.jobs.v1.Job.prototype.hasCreatedAt = function() {
  return jspb.Message.getField(this, 17) != null;
};


/**
 * optional google.protobuf.Timestamp updated_at = 18;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.acompanha.jobs.v1.Job.prototype.getUpdatedAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 18));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.acompanha.jobs.v1.Job} returns this
*/
proto.acompanha.jobs.v1.Job.prototype.setUpdatedAt = function(value) {
  return jspb.Message.setWrapperField(this, 18, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.acompanha.jobs.v1.Job} returns this
 */
proto.acompanha.jobs.v1.Job.prototype.clearUpdatedAt = function() {
  return this.setUpdatedAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.acompanha.jobs.v1.Job.prototype.hasUpdatedAt = function() {
  return jspb.Message.getField(this, 18) != null;
};


/**
 * optional int32 actual_filament_consumption_grams = 19;
 * @return {number}
 */
proto.acompanha.jobs.v1.Job.prototype.getActualFilamentConsumptionGrams = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 19, 0));
};


/**
 * @param {number} value
 * @return {!proto.acompanha.jobs.v1.Job} returns this
 */
proto.acompanha.jobs.v1.Job.prototype.setActualFilamentConsumptionGrams = function(value) {
  return jspb.Message.setField(this, 19, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.acompanha.jobs.v1.Job} returns this
 */
proto.acompanha.jobs.v1.Job.prototype.clearActualFilamentConsumptionGrams = function() {
  return jspb.Message.setField(this, 19, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.acompanha.jobs.v1.Job.prototype.hasActualFilamentConsumptionGrams = function() {
  return jspb.Message.getField(this, 19) != null;
};


/**
 * optional bool filament_pending = 20;
 * @return {boolean}
 */
proto.acompanha.jobs.v1.Job.prototype.getFilamentPending = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 20, false));
};


/**
 * @param {boolean} value
 * @return {!proto.acompanha.jobs.v1.Job} returns this
 */
proto.acompanha.jobs.v1.Job.prototype.setFilamentPending = function(value) {
  return jspb.Message.setProto3BooleanField(this, 20, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.acompanha.jobs.v1.PrinterStat.repeatedFields_ = [9];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.jobs.v1.PrinterStat.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.jobs.v1.PrinterStat.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.jobs.v1.PrinterStat} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.jobs.v1.PrinterStat.toObject = function(includeInstance, msg) {
  var f, obj = {
printerUuid: jspb.Message.getFieldWithDefault(msg, 1, ""),
totalJobs: jspb.Message.getFieldWithDefault(msg, 2, 0),
totalObjects: jspb.Message.getFieldWithDefault(msg, 3, 0),
totalPrinted: jspb.Message.getFieldWithDefault(msg, 4, 0),
successRate: jspb.Message.getFloatingPointFieldWithDefault(msg, 5, 0.0),
totalDurationMinutes: jspb.Message.getFieldWithDefault(msg, 6, 0),
totalFilamentGrams: jspb.Message.getFieldWithDefault(msg, 7, 0),
filamentPendingJobs: jspb.Message.getFieldWithDefault(msg, 8, 0),
filamentsList: jspb.Message.toObjectList(msg.getFilamentsList(),
    acompanha_printers_v1_printers_pb.PrinterFilamentAssignment.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.jobs.v1.PrinterStat}
 */
proto.acompanha.jobs.v1.PrinterStat.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.jobs.v1.PrinterStat;
  return proto.acompanha.jobs.v1.PrinterStat.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.jobs.v1.PrinterStat} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.jobs.v1.PrinterStat}
 */
proto.acompanha.jobs.v1.PrinterStat.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setPrinterUuid(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTotalJobs(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTotalObjects(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTotalPrinted(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setSuccessRate(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTotalDurationMinutes(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTotalFilamentGrams(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setFilamentPendingJobs(value);
      break;
    case 9:
      var value = new acompanha_printers_v1_printers_pb.PrinterFilamentAssignment;
      reader.readMessage(value,acompanha_printers_v1_printers_pb.PrinterFilamentAssignment.deserializeBinaryFromReader);
      msg.addFilaments(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.jobs.v1.PrinterStat.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.jobs.v1.PrinterStat.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.jobs.v1.PrinterStat} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.jobs.v1.PrinterStat.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPrinterUuid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getTotalJobs();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getTotalObjects();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getTotalPrinted();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
  f = message.getSuccessRate();
  if (f !== 0.0) {
    writer.writeDouble(
      5,
      f
    );
  }
  f = message.getTotalDurationMinutes();
  if (f !== 0) {
    writer.writeInt32(
      6,
      f
    );
  }
  f = message.getTotalFilamentGrams();
  if (f !== 0) {
    writer.writeInt32(
      7,
      f
    );
  }
  f = message.getFilamentPendingJobs();
  if (f !== 0) {
    writer.writeInt32(
      8,
      f
    );
  }
  f = message.getFilamentsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      9,
      f,
      acompanha_printers_v1_printers_pb.PrinterFilamentAssignment.serializeBinaryToWriter
    );
  }
};


/**
 * optional string printer_uuid = 1;
 * @return {string}
 */
proto.acompanha.jobs.v1.PrinterStat.prototype.getPrinterUuid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.jobs.v1.PrinterStat} returns this
 */
proto.acompanha.jobs.v1.PrinterStat.prototype.setPrinterUuid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int32 total_jobs = 2;
 * @return {number}
 */
proto.acompanha.jobs.v1.PrinterStat.prototype.getTotalJobs = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.acompanha.jobs.v1.PrinterStat} returns this
 */
proto.acompanha.jobs.v1.PrinterStat.prototype.setTotalJobs = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int32 total_objects = 3;
 * @return {number}
 */
proto.acompanha.jobs.v1.PrinterStat.prototype.getTotalObjects = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.acompanha.jobs.v1.PrinterStat} returns this
 */
proto.acompanha.jobs.v1.PrinterStat.prototype.setTotalObjects = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int32 total_printed = 4;
 * @return {number}
 */
proto.acompanha.jobs.v1.PrinterStat.prototype.getTotalPrinted = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.acompanha.jobs.v1.PrinterStat} returns this
 */
proto.acompanha.jobs.v1.PrinterStat.prototype.setTotalPrinted = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional double success_rate = 5;
 * @return {number}
 */
proto.acompanha.jobs.v1.PrinterStat.prototype.getSuccessRate = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 5, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.acompanha.jobs.v1.PrinterStat} returns this
 */
proto.acompanha.jobs.v1.PrinterStat.prototype.setSuccessRate = function(value) {
  return jspb.Message.setProto3FloatField(this, 5, value);
};


/**
 * optional int32 total_duration_minutes = 6;
 * @return {number}
 */
proto.acompanha.jobs.v1.PrinterStat.prototype.getTotalDurationMinutes = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.acompanha.jobs.v1.PrinterStat} returns this
 */
proto.acompanha.jobs.v1.PrinterStat.prototype.setTotalDurationMinutes = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional int32 total_filament_grams = 7;
 * @return {number}
 */
proto.acompanha.jobs.v1.PrinterStat.prototype.getTotalFilamentGrams = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.acompanha.jobs.v1.PrinterStat} returns this
 */
proto.acompanha.jobs.v1.PrinterStat.prototype.setTotalFilamentGrams = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};


/**
 * optional int32 filament_pending_jobs = 8;
 * @return {number}
 */
proto.acompanha.jobs.v1.PrinterStat.prototype.getFilamentPendingJobs = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {number} value
 * @return {!proto.acompanha.jobs.v1.PrinterStat} returns this
 */
proto.acompanha.jobs.v1.PrinterStat.prototype.setFilamentPendingJobs = function(value) {
  return jspb.Message.setProto3IntField(this, 8, value);
};


/**
 * repeated acompanha.printers.v1.PrinterFilamentAssignment filaments = 9;
 * @return {!Array<!proto.acompanha.printers.v1.PrinterFilamentAssignment>}
 */
proto.acompanha.jobs.v1.PrinterStat.prototype.getFilamentsList = function() {
  return /** @type{!Array<!proto.acompanha.printers.v1.PrinterFilamentAssignment>} */ (
    jspb.Message.getRepeatedWrapperField(this, acompanha_printers_v1_printers_pb.PrinterFilamentAssignment, 9));
};


/**
 * @param {!Array<!proto.acompanha.printers.v1.PrinterFilamentAssignment>} value
 * @return {!proto.acompanha.jobs.v1.PrinterStat} returns this
*/
proto.acompanha.jobs.v1.PrinterStat.prototype.setFilamentsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 9, value);
};


/**
 * @param {!proto.acompanha.printers.v1.PrinterFilamentAssignment=} opt_value
 * @param {number=} opt_index
 * @return {!proto.acompanha.printers.v1.PrinterFilamentAssignment}
 */
proto.acompanha.jobs.v1.PrinterStat.prototype.addFilaments = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 9, opt_value, proto.acompanha.printers.v1.PrinterFilamentAssignment, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.acompanha.jobs.v1.PrinterStat} returns this
 */
proto.acompanha.jobs.v1.PrinterStat.prototype.clearFilamentsList = function() {
  return this.setFilamentsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.jobs.v1.ListJobsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.jobs.v1.ListJobsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.jobs.v1.ListJobsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.jobs.v1.ListJobsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
pagination: (f = msg.getPagination()) && acompanha_common_v1_common_pb.PaginationRequest.toObject(includeInstance, f),
printerUuid: jspb.Message.getFieldWithDefault(msg, 2, ""),
status: jspb.Message.getFieldWithDefault(msg, 3, ""),
finishedFrom: (f = msg.getFinishedFrom()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
finishedTo: (f = msg.getFinishedTo()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.jobs.v1.ListJobsRequest}
 */
proto.acompanha.jobs.v1.ListJobsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.jobs.v1.ListJobsRequest;
  return proto.acompanha.jobs.v1.ListJobsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.jobs.v1.ListJobsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.jobs.v1.ListJobsRequest}
 */
proto.acompanha.jobs.v1.ListJobsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new acompanha_common_v1_common_pb.PaginationRequest;
      reader.readMessage(value,acompanha_common_v1_common_pb.PaginationRequest.deserializeBinaryFromReader);
      msg.setPagination(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setPrinterUuid(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setStatus(value);
      break;
    case 4:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setFinishedFrom(value);
      break;
    case 5:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setFinishedTo(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.jobs.v1.ListJobsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.jobs.v1.ListJobsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.jobs.v1.ListJobsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.jobs.v1.ListJobsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPagination();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      acompanha_common_v1_common_pb.PaginationRequest.serializeBinaryToWriter
    );
  }
  f = message.getPrinterUuid();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getStatus();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getFinishedFrom();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getFinishedTo();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
};


/**
 * optional acompanha.common.v1.PaginationRequest pagination = 1;
 * @return {?proto.acompanha.common.v1.PaginationRequest}
 */
proto.acompanha.jobs.v1.ListJobsRequest.prototype.getPagination = function() {
  return /** @type{?proto.acompanha.common.v1.PaginationRequest} */ (
    jspb.Message.getWrapperField(this, acompanha_common_v1_common_pb.PaginationRequest, 1));
};


/**
 * @param {?proto.acompanha.common.v1.PaginationRequest|undefined} value
 * @return {!proto.acompanha.jobs.v1.ListJobsRequest} returns this
*/
proto.acompanha.jobs.v1.ListJobsRequest.prototype.setPagination = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.acompanha.jobs.v1.ListJobsRequest} returns this
 */
proto.acompanha.jobs.v1.ListJobsRequest.prototype.clearPagination = function() {
  return this.setPagination(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.acompanha.jobs.v1.ListJobsRequest.prototype.hasPagination = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string printer_uuid = 2;
 * @return {string}
 */
proto.acompanha.jobs.v1.ListJobsRequest.prototype.getPrinterUuid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.jobs.v1.ListJobsRequest} returns this
 */
proto.acompanha.jobs.v1.ListJobsRequest.prototype.setPrinterUuid = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string status = 3;
 * @return {string}
 */
proto.acompanha.jobs.v1.ListJobsRequest.prototype.getStatus = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.jobs.v1.ListJobsRequest} returns this
 */
proto.acompanha.jobs.v1.ListJobsRequest.prototype.setStatus = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional google.protobuf.Timestamp finished_from = 4;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.acompanha.jobs.v1.ListJobsRequest.prototype.getFinishedFrom = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 4));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.acompanha.jobs.v1.ListJobsRequest} returns this
*/
proto.acompanha.jobs.v1.ListJobsRequest.prototype.setFinishedFrom = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.acompanha.jobs.v1.ListJobsRequest} returns this
 */
proto.acompanha.jobs.v1.ListJobsRequest.prototype.clearFinishedFrom = function() {
  return this.setFinishedFrom(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.acompanha.jobs.v1.ListJobsRequest.prototype.hasFinishedFrom = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional google.protobuf.Timestamp finished_to = 5;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.acompanha.jobs.v1.ListJobsRequest.prototype.getFinishedTo = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 5));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.acompanha.jobs.v1.ListJobsRequest} returns this
*/
proto.acompanha.jobs.v1.ListJobsRequest.prototype.setFinishedTo = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.acompanha.jobs.v1.ListJobsRequest} returns this
 */
proto.acompanha.jobs.v1.ListJobsRequest.prototype.clearFinishedTo = function() {
  return this.setFinishedTo(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.acompanha.jobs.v1.ListJobsRequest.prototype.hasFinishedTo = function() {
  return jspb.Message.getField(this, 5) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.jobs.v1.ListJobsByPrinterRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.jobs.v1.ListJobsByPrinterRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.jobs.v1.ListJobsByPrinterRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.jobs.v1.ListJobsByPrinterRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
printerUuid: jspb.Message.getFieldWithDefault(msg, 1, ""),
pagination: (f = msg.getPagination()) && acompanha_common_v1_common_pb.PaginationRequest.toObject(includeInstance, f),
status: jspb.Message.getFieldWithDefault(msg, 3, ""),
finishedFrom: (f = msg.getFinishedFrom()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
finishedTo: (f = msg.getFinishedTo()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.jobs.v1.ListJobsByPrinterRequest}
 */
proto.acompanha.jobs.v1.ListJobsByPrinterRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.jobs.v1.ListJobsByPrinterRequest;
  return proto.acompanha.jobs.v1.ListJobsByPrinterRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.jobs.v1.ListJobsByPrinterRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.jobs.v1.ListJobsByPrinterRequest}
 */
proto.acompanha.jobs.v1.ListJobsByPrinterRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setPrinterUuid(value);
      break;
    case 2:
      var value = new acompanha_common_v1_common_pb.PaginationRequest;
      reader.readMessage(value,acompanha_common_v1_common_pb.PaginationRequest.deserializeBinaryFromReader);
      msg.setPagination(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setStatus(value);
      break;
    case 4:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setFinishedFrom(value);
      break;
    case 5:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setFinishedTo(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.jobs.v1.ListJobsByPrinterRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.jobs.v1.ListJobsByPrinterRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.jobs.v1.ListJobsByPrinterRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.jobs.v1.ListJobsByPrinterRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPrinterUuid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getPagination();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      acompanha_common_v1_common_pb.PaginationRequest.serializeBinaryToWriter
    );
  }
  f = message.getStatus();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getFinishedFrom();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getFinishedTo();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
};


/**
 * optional string printer_uuid = 1;
 * @return {string}
 */
proto.acompanha.jobs.v1.ListJobsByPrinterRequest.prototype.getPrinterUuid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.jobs.v1.ListJobsByPrinterRequest} returns this
 */
proto.acompanha.jobs.v1.ListJobsByPrinterRequest.prototype.setPrinterUuid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional acompanha.common.v1.PaginationRequest pagination = 2;
 * @return {?proto.acompanha.common.v1.PaginationRequest}
 */
proto.acompanha.jobs.v1.ListJobsByPrinterRequest.prototype.getPagination = function() {
  return /** @type{?proto.acompanha.common.v1.PaginationRequest} */ (
    jspb.Message.getWrapperField(this, acompanha_common_v1_common_pb.PaginationRequest, 2));
};


/**
 * @param {?proto.acompanha.common.v1.PaginationRequest|undefined} value
 * @return {!proto.acompanha.jobs.v1.ListJobsByPrinterRequest} returns this
*/
proto.acompanha.jobs.v1.ListJobsByPrinterRequest.prototype.setPagination = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.acompanha.jobs.v1.ListJobsByPrinterRequest} returns this
 */
proto.acompanha.jobs.v1.ListJobsByPrinterRequest.prototype.clearPagination = function() {
  return this.setPagination(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.acompanha.jobs.v1.ListJobsByPrinterRequest.prototype.hasPagination = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional string status = 3;
 * @return {string}
 */
proto.acompanha.jobs.v1.ListJobsByPrinterRequest.prototype.getStatus = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.jobs.v1.ListJobsByPrinterRequest} returns this
 */
proto.acompanha.jobs.v1.ListJobsByPrinterRequest.prototype.setStatus = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional google.protobuf.Timestamp finished_from = 4;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.acompanha.jobs.v1.ListJobsByPrinterRequest.prototype.getFinishedFrom = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 4));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.acompanha.jobs.v1.ListJobsByPrinterRequest} returns this
*/
proto.acompanha.jobs.v1.ListJobsByPrinterRequest.prototype.setFinishedFrom = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.acompanha.jobs.v1.ListJobsByPrinterRequest} returns this
 */
proto.acompanha.jobs.v1.ListJobsByPrinterRequest.prototype.clearFinishedFrom = function() {
  return this.setFinishedFrom(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.acompanha.jobs.v1.ListJobsByPrinterRequest.prototype.hasFinishedFrom = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional google.protobuf.Timestamp finished_to = 5;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.acompanha.jobs.v1.ListJobsByPrinterRequest.prototype.getFinishedTo = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 5));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.acompanha.jobs.v1.ListJobsByPrinterRequest} returns this
*/
proto.acompanha.jobs.v1.ListJobsByPrinterRequest.prototype.setFinishedTo = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.acompanha.jobs.v1.ListJobsByPrinterRequest} returns this
 */
proto.acompanha.jobs.v1.ListJobsByPrinterRequest.prototype.clearFinishedTo = function() {
  return this.setFinishedTo(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.acompanha.jobs.v1.ListJobsByPrinterRequest.prototype.hasFinishedTo = function() {
  return jspb.Message.getField(this, 5) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.acompanha.jobs.v1.ListJobsResponse.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.jobs.v1.ListJobsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.jobs.v1.ListJobsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.jobs.v1.ListJobsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.jobs.v1.ListJobsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
success: jspb.Message.getBooleanFieldWithDefault(msg, 1, false),
jobsList: jspb.Message.toObjectList(msg.getJobsList(),
    proto.acompanha.jobs.v1.Job.toObject, includeInstance),
meta: (f = msg.getMeta()) && acompanha_common_v1_common_pb.PaginationMeta.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.jobs.v1.ListJobsResponse}
 */
proto.acompanha.jobs.v1.ListJobsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.jobs.v1.ListJobsResponse;
  return proto.acompanha.jobs.v1.ListJobsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.jobs.v1.ListJobsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.jobs.v1.ListJobsResponse}
 */
proto.acompanha.jobs.v1.ListJobsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSuccess(value);
      break;
    case 2:
      var value = new proto.acompanha.jobs.v1.Job;
      reader.readMessage(value,proto.acompanha.jobs.v1.Job.deserializeBinaryFromReader);
      msg.addJobs(value);
      break;
    case 3:
      var value = new acompanha_common_v1_common_pb.PaginationMeta;
      reader.readMessage(value,acompanha_common_v1_common_pb.PaginationMeta.deserializeBinaryFromReader);
      msg.setMeta(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.jobs.v1.ListJobsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.jobs.v1.ListJobsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.jobs.v1.ListJobsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.jobs.v1.ListJobsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSuccess();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
  f = message.getJobsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.acompanha.jobs.v1.Job.serializeBinaryToWriter
    );
  }
  f = message.getMeta();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      acompanha_common_v1_common_pb.PaginationMeta.serializeBinaryToWriter
    );
  }
};


/**
 * optional bool success = 1;
 * @return {boolean}
 */
proto.acompanha.jobs.v1.ListJobsResponse.prototype.getSuccess = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.acompanha.jobs.v1.ListJobsResponse} returns this
 */
proto.acompanha.jobs.v1.ListJobsResponse.prototype.setSuccess = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};


/**
 * repeated Job jobs = 2;
 * @return {!Array<!proto.acompanha.jobs.v1.Job>}
 */
proto.acompanha.jobs.v1.ListJobsResponse.prototype.getJobsList = function() {
  return /** @type{!Array<!proto.acompanha.jobs.v1.Job>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.acompanha.jobs.v1.Job, 2));
};


/**
 * @param {!Array<!proto.acompanha.jobs.v1.Job>} value
 * @return {!proto.acompanha.jobs.v1.ListJobsResponse} returns this
*/
proto.acompanha.jobs.v1.ListJobsResponse.prototype.setJobsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.acompanha.jobs.v1.Job=} opt_value
 * @param {number=} opt_index
 * @return {!proto.acompanha.jobs.v1.Job}
 */
proto.acompanha.jobs.v1.ListJobsResponse.prototype.addJobs = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.acompanha.jobs.v1.Job, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.acompanha.jobs.v1.ListJobsResponse} returns this
 */
proto.acompanha.jobs.v1.ListJobsResponse.prototype.clearJobsList = function() {
  return this.setJobsList([]);
};


/**
 * optional acompanha.common.v1.PaginationMeta meta = 3;
 * @return {?proto.acompanha.common.v1.PaginationMeta}
 */
proto.acompanha.jobs.v1.ListJobsResponse.prototype.getMeta = function() {
  return /** @type{?proto.acompanha.common.v1.PaginationMeta} */ (
    jspb.Message.getWrapperField(this, acompanha_common_v1_common_pb.PaginationMeta, 3));
};


/**
 * @param {?proto.acompanha.common.v1.PaginationMeta|undefined} value
 * @return {!proto.acompanha.jobs.v1.ListJobsResponse} returns this
*/
proto.acompanha.jobs.v1.ListJobsResponse.prototype.setMeta = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.acompanha.jobs.v1.ListJobsResponse} returns this
 */
proto.acompanha.jobs.v1.ListJobsResponse.prototype.clearMeta = function() {
  return this.setMeta(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.acompanha.jobs.v1.ListJobsResponse.prototype.hasMeta = function() {
  return jspb.Message.getField(this, 3) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.jobs.v1.GetJobRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.jobs.v1.GetJobRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.jobs.v1.GetJobRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.jobs.v1.GetJobRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
uuid: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.jobs.v1.GetJobRequest}
 */
proto.acompanha.jobs.v1.GetJobRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.jobs.v1.GetJobRequest;
  return proto.acompanha.jobs.v1.GetJobRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.jobs.v1.GetJobRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.jobs.v1.GetJobRequest}
 */
proto.acompanha.jobs.v1.GetJobRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUuid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.jobs.v1.GetJobRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.jobs.v1.GetJobRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.jobs.v1.GetJobRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.jobs.v1.GetJobRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUuid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string uuid = 1;
 * @return {string}
 */
proto.acompanha.jobs.v1.GetJobRequest.prototype.getUuid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.jobs.v1.GetJobRequest} returns this
 */
proto.acompanha.jobs.v1.GetJobRequest.prototype.setUuid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.jobs.v1.GetJobResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.jobs.v1.GetJobResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.jobs.v1.GetJobResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.jobs.v1.GetJobResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
success: jspb.Message.getBooleanFieldWithDefault(msg, 1, false),
data: (f = msg.getData()) && proto.acompanha.jobs.v1.Job.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.jobs.v1.GetJobResponse}
 */
proto.acompanha.jobs.v1.GetJobResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.jobs.v1.GetJobResponse;
  return proto.acompanha.jobs.v1.GetJobResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.jobs.v1.GetJobResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.jobs.v1.GetJobResponse}
 */
proto.acompanha.jobs.v1.GetJobResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSuccess(value);
      break;
    case 2:
      var value = new proto.acompanha.jobs.v1.Job;
      reader.readMessage(value,proto.acompanha.jobs.v1.Job.deserializeBinaryFromReader);
      msg.setData(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.jobs.v1.GetJobResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.jobs.v1.GetJobResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.jobs.v1.GetJobResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.jobs.v1.GetJobResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSuccess();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
  f = message.getData();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.acompanha.jobs.v1.Job.serializeBinaryToWriter
    );
  }
};


/**
 * optional bool success = 1;
 * @return {boolean}
 */
proto.acompanha.jobs.v1.GetJobResponse.prototype.getSuccess = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.acompanha.jobs.v1.GetJobResponse} returns this
 */
proto.acompanha.jobs.v1.GetJobResponse.prototype.setSuccess = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};


/**
 * optional Job data = 2;
 * @return {?proto.acompanha.jobs.v1.Job}
 */
proto.acompanha.jobs.v1.GetJobResponse.prototype.getData = function() {
  return /** @type{?proto.acompanha.jobs.v1.Job} */ (
    jspb.Message.getWrapperField(this, proto.acompanha.jobs.v1.Job, 2));
};


/**
 * @param {?proto.acompanha.jobs.v1.Job|undefined} value
 * @return {!proto.acompanha.jobs.v1.GetJobResponse} returns this
*/
proto.acompanha.jobs.v1.GetJobResponse.prototype.setData = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.acompanha.jobs.v1.GetJobResponse} returns this
 */
proto.acompanha.jobs.v1.GetJobResponse.prototype.clearData = function() {
  return this.setData(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.acompanha.jobs.v1.GetJobResponse.prototype.hasData = function() {
  return jspb.Message.getField(this, 2) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.acompanha.jobs.v1.CreateJobRequest.repeatedFields_ = [12];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.jobs.v1.CreateJobRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.jobs.v1.CreateJobRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.jobs.v1.CreateJobRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.jobs.v1.CreateJobRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
printerUuid: jspb.Message.getFieldWithDefault(msg, 1, ""),
fileName: jspb.Message.getFieldWithDefault(msg, 2, ""),
jobId: jspb.Message.getFieldWithDefault(msg, 3, ""),
estimatedDurationMinutes: jspb.Message.getFieldWithDefault(msg, 4, 0),
estimatedFilamentConsumptionGrams: jspb.Message.getFieldWithDefault(msg, 5, 0),
startedAt: (f = msg.getStartedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
finishedAt: (f = msg.getFinishedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
status: jspb.Message.getFieldWithDefault(msg, 8, ""),
statusReason: jspb.Message.getFieldWithDefault(msg, 9, ""),
objectCount: jspb.Message.getFieldWithDefault(msg, 10, 0),
printedCount: jspb.Message.getFieldWithDefault(msg, 11, 0),
filamentsList: jspb.Message.toObjectList(msg.getFilamentsList(),
    proto.acompanha.jobs.v1.JobFilament.toObject, includeInstance),
metadataJson: jspb.Message.getFieldWithDefault(msg, 13, ""),
actualFilamentConsumptionGrams: (f = jspb.Message.getField(msg, 14)) == null ? undefined : f,
filamentsProvided: jspb.Message.getBooleanFieldWithDefault(msg, 15, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.jobs.v1.CreateJobRequest}
 */
proto.acompanha.jobs.v1.CreateJobRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.jobs.v1.CreateJobRequest;
  return proto.acompanha.jobs.v1.CreateJobRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.jobs.v1.CreateJobRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.jobs.v1.CreateJobRequest}
 */
proto.acompanha.jobs.v1.CreateJobRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setPrinterUuid(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setFileName(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setJobId(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setEstimatedDurationMinutes(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setEstimatedFilamentConsumptionGrams(value);
      break;
    case 6:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setStartedAt(value);
      break;
    case 7:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setFinishedAt(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setStatus(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setStatusReason(value);
      break;
    case 10:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setObjectCount(value);
      break;
    case 11:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPrintedCount(value);
      break;
    case 12:
      var value = new proto.acompanha.jobs.v1.JobFilament;
      reader.readMessage(value,proto.acompanha.jobs.v1.JobFilament.deserializeBinaryFromReader);
      msg.addFilaments(value);
      break;
    case 13:
      var value = /** @type {string} */ (reader.readString());
      msg.setMetadataJson(value);
      break;
    case 14:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setActualFilamentConsumptionGrams(value);
      break;
    case 15:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setFilamentsProvided(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.jobs.v1.CreateJobRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.jobs.v1.CreateJobRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.jobs.v1.CreateJobRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.jobs.v1.CreateJobRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPrinterUuid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getFileName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getJobId();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getEstimatedDurationMinutes();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
  f = message.getEstimatedFilamentConsumptionGrams();
  if (f !== 0) {
    writer.writeInt32(
      5,
      f
    );
  }
  f = message.getStartedAt();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getFinishedAt();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getStatus();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getStatusReason();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getObjectCount();
  if (f !== 0) {
    writer.writeInt32(
      10,
      f
    );
  }
  f = message.getPrintedCount();
  if (f !== 0) {
    writer.writeInt32(
      11,
      f
    );
  }
  f = message.getFilamentsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      12,
      f,
      proto.acompanha.jobs.v1.JobFilament.serializeBinaryToWriter
    );
  }
  f = message.getMetadataJson();
  if (f.length > 0) {
    writer.writeString(
      13,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 14));
  if (f != null) {
    writer.writeInt32(
      14,
      f
    );
  }
  f = message.getFilamentsProvided();
  if (f) {
    writer.writeBool(
      15,
      f
    );
  }
};


/**
 * optional string printer_uuid = 1;
 * @return {string}
 */
proto.acompanha.jobs.v1.CreateJobRequest.prototype.getPrinterUuid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.jobs.v1.CreateJobRequest} returns this
 */
proto.acompanha.jobs.v1.CreateJobRequest.prototype.setPrinterUuid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string file_name = 2;
 * @return {string}
 */
proto.acompanha.jobs.v1.CreateJobRequest.prototype.getFileName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.jobs.v1.CreateJobRequest} returns this
 */
proto.acompanha.jobs.v1.CreateJobRequest.prototype.setFileName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string job_id = 3;
 * @return {string}
 */
proto.acompanha.jobs.v1.CreateJobRequest.prototype.getJobId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.jobs.v1.CreateJobRequest} returns this
 */
proto.acompanha.jobs.v1.CreateJobRequest.prototype.setJobId = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional int32 estimated_duration_minutes = 4;
 * @return {number}
 */
proto.acompanha.jobs.v1.CreateJobRequest.prototype.getEstimatedDurationMinutes = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.acompanha.jobs.v1.CreateJobRequest} returns this
 */
proto.acompanha.jobs.v1.CreateJobRequest.prototype.setEstimatedDurationMinutes = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional int32 estimated_filament_consumption_grams = 5;
 * @return {number}
 */
proto.acompanha.jobs.v1.CreateJobRequest.prototype.getEstimatedFilamentConsumptionGrams = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.acompanha.jobs.v1.CreateJobRequest} returns this
 */
proto.acompanha.jobs.v1.CreateJobRequest.prototype.setEstimatedFilamentConsumptionGrams = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional google.protobuf.Timestamp started_at = 6;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.acompanha.jobs.v1.CreateJobRequest.prototype.getStartedAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 6));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.acompanha.jobs.v1.CreateJobRequest} returns this
*/
proto.acompanha.jobs.v1.CreateJobRequest.prototype.setStartedAt = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.acompanha.jobs.v1.CreateJobRequest} returns this
 */
proto.acompanha.jobs.v1.CreateJobRequest.prototype.clearStartedAt = function() {
  return this.setStartedAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.acompanha.jobs.v1.CreateJobRequest.prototype.hasStartedAt = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional google.protobuf.Timestamp finished_at = 7;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.acompanha.jobs.v1.CreateJobRequest.prototype.getFinishedAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 7));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.acompanha.jobs.v1.CreateJobRequest} returns this
*/
proto.acompanha.jobs.v1.CreateJobRequest.prototype.setFinishedAt = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.acompanha.jobs.v1.CreateJobRequest} returns this
 */
proto.acompanha.jobs.v1.CreateJobRequest.prototype.clearFinishedAt = function() {
  return this.setFinishedAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.acompanha.jobs.v1.CreateJobRequest.prototype.hasFinishedAt = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional string status = 8;
 * @return {string}
 */
proto.acompanha.jobs.v1.CreateJobRequest.prototype.getStatus = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.jobs.v1.CreateJobRequest} returns this
 */
proto.acompanha.jobs.v1.CreateJobRequest.prototype.setStatus = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional string status_reason = 9;
 * @return {string}
 */
proto.acompanha.jobs.v1.CreateJobRequest.prototype.getStatusReason = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.jobs.v1.CreateJobRequest} returns this
 */
proto.acompanha.jobs.v1.CreateJobRequest.prototype.setStatusReason = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional int32 object_count = 10;
 * @return {number}
 */
proto.acompanha.jobs.v1.CreateJobRequest.prototype.getObjectCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};


/**
 * @param {number} value
 * @return {!proto.acompanha.jobs.v1.CreateJobRequest} returns this
 */
proto.acompanha.jobs.v1.CreateJobRequest.prototype.setObjectCount = function(value) {
  return jspb.Message.setProto3IntField(this, 10, value);
};


/**
 * optional int32 printed_count = 11;
 * @return {number}
 */
proto.acompanha.jobs.v1.CreateJobRequest.prototype.getPrintedCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 11, 0));
};


/**
 * @param {number} value
 * @return {!proto.acompanha.jobs.v1.CreateJobRequest} returns this
 */
proto.acompanha.jobs.v1.CreateJobRequest.prototype.setPrintedCount = function(value) {
  return jspb.Message.setProto3IntField(this, 11, value);
};


/**
 * repeated JobFilament filaments = 12;
 * @return {!Array<!proto.acompanha.jobs.v1.JobFilament>}
 */
proto.acompanha.jobs.v1.CreateJobRequest.prototype.getFilamentsList = function() {
  return /** @type{!Array<!proto.acompanha.jobs.v1.JobFilament>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.acompanha.jobs.v1.JobFilament, 12));
};


/**
 * @param {!Array<!proto.acompanha.jobs.v1.JobFilament>} value
 * @return {!proto.acompanha.jobs.v1.CreateJobRequest} returns this
*/
proto.acompanha.jobs.v1.CreateJobRequest.prototype.setFilamentsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 12, value);
};


/**
 * @param {!proto.acompanha.jobs.v1.JobFilament=} opt_value
 * @param {number=} opt_index
 * @return {!proto.acompanha.jobs.v1.JobFilament}
 */
proto.acompanha.jobs.v1.CreateJobRequest.prototype.addFilaments = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 12, opt_value, proto.acompanha.jobs.v1.JobFilament, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.acompanha.jobs.v1.CreateJobRequest} returns this
 */
proto.acompanha.jobs.v1.CreateJobRequest.prototype.clearFilamentsList = function() {
  return this.setFilamentsList([]);
};


/**
 * optional string metadata_json = 13;
 * @return {string}
 */
proto.acompanha.jobs.v1.CreateJobRequest.prototype.getMetadataJson = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 13, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.jobs.v1.CreateJobRequest} returns this
 */
proto.acompanha.jobs.v1.CreateJobRequest.prototype.setMetadataJson = function(value) {
  return jspb.Message.setProto3StringField(this, 13, value);
};


/**
 * optional int32 actual_filament_consumption_grams = 14;
 * @return {number}
 */
proto.acompanha.jobs.v1.CreateJobRequest.prototype.getActualFilamentConsumptionGrams = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 14, 0));
};


/**
 * @param {number} value
 * @return {!proto.acompanha.jobs.v1.CreateJobRequest} returns this
 */
proto.acompanha.jobs.v1.CreateJobRequest.prototype.setActualFilamentConsumptionGrams = function(value) {
  return jspb.Message.setField(this, 14, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.acompanha.jobs.v1.CreateJobRequest} returns this
 */
proto.acompanha.jobs.v1.CreateJobRequest.prototype.clearActualFilamentConsumptionGrams = function() {
  return jspb.Message.setField(this, 14, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.acompanha.jobs.v1.CreateJobRequest.prototype.hasActualFilamentConsumptionGrams = function() {
  return jspb.Message.getField(this, 14) != null;
};


/**
 * optional bool filaments_provided = 15;
 * @return {boolean}
 */
proto.acompanha.jobs.v1.CreateJobRequest.prototype.getFilamentsProvided = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 15, false));
};


/**
 * @param {boolean} value
 * @return {!proto.acompanha.jobs.v1.CreateJobRequest} returns this
 */
proto.acompanha.jobs.v1.CreateJobRequest.prototype.setFilamentsProvided = function(value) {
  return jspb.Message.setProto3BooleanField(this, 15, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.acompanha.jobs.v1.CreateJobResponse.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.jobs.v1.CreateJobResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.jobs.v1.CreateJobResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.jobs.v1.CreateJobResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.jobs.v1.CreateJobResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
success: jspb.Message.getBooleanFieldWithDefault(msg, 1, false),
data: (f = msg.getData()) && proto.acompanha.jobs.v1.Job.toObject(includeInstance, f),
warningsList: (f = jspb.Message.getRepeatedField(msg, 3)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.jobs.v1.CreateJobResponse}
 */
proto.acompanha.jobs.v1.CreateJobResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.jobs.v1.CreateJobResponse;
  return proto.acompanha.jobs.v1.CreateJobResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.jobs.v1.CreateJobResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.jobs.v1.CreateJobResponse}
 */
proto.acompanha.jobs.v1.CreateJobResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSuccess(value);
      break;
    case 2:
      var value = new proto.acompanha.jobs.v1.Job;
      reader.readMessage(value,proto.acompanha.jobs.v1.Job.deserializeBinaryFromReader);
      msg.setData(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.addWarnings(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.jobs.v1.CreateJobResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.jobs.v1.CreateJobResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.jobs.v1.CreateJobResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.jobs.v1.CreateJobResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSuccess();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
  f = message.getData();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.acompanha.jobs.v1.Job.serializeBinaryToWriter
    );
  }
  f = message.getWarningsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      3,
      f
    );
  }
};


/**
 * optional bool success = 1;
 * @return {boolean}
 */
proto.acompanha.jobs.v1.CreateJobResponse.prototype.getSuccess = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.acompanha.jobs.v1.CreateJobResponse} returns this
 */
proto.acompanha.jobs.v1.CreateJobResponse.prototype.setSuccess = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};


/**
 * optional Job data = 2;
 * @return {?proto.acompanha.jobs.v1.Job}
 */
proto.acompanha.jobs.v1.CreateJobResponse.prototype.getData = function() {
  return /** @type{?proto.acompanha.jobs.v1.Job} */ (
    jspb.Message.getWrapperField(this, proto.acompanha.jobs.v1.Job, 2));
};


/**
 * @param {?proto.acompanha.jobs.v1.Job|undefined} value
 * @return {!proto.acompanha.jobs.v1.CreateJobResponse} returns this
*/
proto.acompanha.jobs.v1.CreateJobResponse.prototype.setData = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.acompanha.jobs.v1.CreateJobResponse} returns this
 */
proto.acompanha.jobs.v1.CreateJobResponse.prototype.clearData = function() {
  return this.setData(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.acompanha.jobs.v1.CreateJobResponse.prototype.hasData = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * repeated string warnings = 3;
 * @return {!Array<string>}
 */
proto.acompanha.jobs.v1.CreateJobResponse.prototype.getWarningsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 3));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.acompanha.jobs.v1.CreateJobResponse} returns this
 */
proto.acompanha.jobs.v1.CreateJobResponse.prototype.setWarningsList = function(value) {
  return jspb.Message.setField(this, 3, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.acompanha.jobs.v1.CreateJobResponse} returns this
 */
proto.acompanha.jobs.v1.CreateJobResponse.prototype.addWarnings = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 3, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.acompanha.jobs.v1.CreateJobResponse} returns this
 */
proto.acompanha.jobs.v1.CreateJobResponse.prototype.clearWarningsList = function() {
  return this.setWarningsList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.acompanha.jobs.v1.UpdateJobRequest.repeatedFields_ = [13];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.jobs.v1.UpdateJobRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.jobs.v1.UpdateJobRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.jobs.v1.UpdateJobRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.jobs.v1.UpdateJobRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
uuid: jspb.Message.getFieldWithDefault(msg, 1, ""),
printerUuid: jspb.Message.getFieldWithDefault(msg, 2, ""),
fileName: jspb.Message.getFieldWithDefault(msg, 3, ""),
jobId: jspb.Message.getFieldWithDefault(msg, 4, ""),
estimatedDurationMinutes: (f = jspb.Message.getField(msg, 5)) == null ? undefined : f,
estimatedFilamentConsumptionGrams: (f = jspb.Message.getField(msg, 6)) == null ? undefined : f,
startedAt: (f = msg.getStartedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
finishedAt: (f = msg.getFinishedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
status: jspb.Message.getFieldWithDefault(msg, 9, ""),
statusReason: jspb.Message.getFieldWithDefault(msg, 10, ""),
objectCount: (f = jspb.Message.getField(msg, 11)) == null ? undefined : f,
printedCount: (f = jspb.Message.getField(msg, 12)) == null ? undefined : f,
filamentsList: jspb.Message.toObjectList(msg.getFilamentsList(),
    proto.acompanha.jobs.v1.JobFilament.toObject, includeInstance),
metadataJson: jspb.Message.getFieldWithDefault(msg, 14, ""),
actualFilamentConsumptionGrams: (f = jspb.Message.getField(msg, 15)) == null ? undefined : f,
filamentsProvided: jspb.Message.getBooleanFieldWithDefault(msg, 16, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.jobs.v1.UpdateJobRequest}
 */
proto.acompanha.jobs.v1.UpdateJobRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.jobs.v1.UpdateJobRequest;
  return proto.acompanha.jobs.v1.UpdateJobRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.jobs.v1.UpdateJobRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.jobs.v1.UpdateJobRequest}
 */
proto.acompanha.jobs.v1.UpdateJobRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUuid(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setPrinterUuid(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setFileName(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setJobId(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setEstimatedDurationMinutes(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setEstimatedFilamentConsumptionGrams(value);
      break;
    case 7:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setStartedAt(value);
      break;
    case 8:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setFinishedAt(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setStatus(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setStatusReason(value);
      break;
    case 11:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setObjectCount(value);
      break;
    case 12:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPrintedCount(value);
      break;
    case 13:
      var value = new proto.acompanha.jobs.v1.JobFilament;
      reader.readMessage(value,proto.acompanha.jobs.v1.JobFilament.deserializeBinaryFromReader);
      msg.addFilaments(value);
      break;
    case 14:
      var value = /** @type {string} */ (reader.readString());
      msg.setMetadataJson(value);
      break;
    case 15:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setActualFilamentConsumptionGrams(value);
      break;
    case 16:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setFilamentsProvided(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.jobs.v1.UpdateJobRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.jobs.v1.UpdateJobRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.jobs.v1.UpdateJobRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.jobs.v1.UpdateJobRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUuid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getPrinterUuid();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getFileName();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getJobId();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 5));
  if (f != null) {
    writer.writeInt32(
      5,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 6));
  if (f != null) {
    writer.writeInt32(
      6,
      f
    );
  }
  f = message.getStartedAt();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getFinishedAt();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getStatus();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getStatusReason();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 11));
  if (f != null) {
    writer.writeInt32(
      11,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 12));
  if (f != null) {
    writer.writeInt32(
      12,
      f
    );
  }
  f = message.getFilamentsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      13,
      f,
      proto.acompanha.jobs.v1.JobFilament.serializeBinaryToWriter
    );
  }
  f = message.getMetadataJson();
  if (f.length > 0) {
    writer.writeString(
      14,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 15));
  if (f != null) {
    writer.writeInt32(
      15,
      f
    );
  }
  f = message.getFilamentsProvided();
  if (f) {
    writer.writeBool(
      16,
      f
    );
  }
};


/**
 * optional string uuid = 1;
 * @return {string}
 */
proto.acompanha.jobs.v1.UpdateJobRequest.prototype.getUuid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.jobs.v1.UpdateJobRequest} returns this
 */
proto.acompanha.jobs.v1.UpdateJobRequest.prototype.setUuid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string printer_uuid = 2;
 * @return {string}
 */
proto.acompanha.jobs.v1.UpdateJobRequest.prototype.getPrinterUuid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.jobs.v1.UpdateJobRequest} returns this
 */
proto.acompanha.jobs.v1.UpdateJobRequest.prototype.setPrinterUuid = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string file_name = 3;
 * @return {string}
 */
proto.acompanha.jobs.v1.UpdateJobRequest.prototype.getFileName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.jobs.v1.UpdateJobRequest} returns this
 */
proto.acompanha.jobs.v1.UpdateJobRequest.prototype.setFileName = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string job_id = 4;
 * @return {string}
 */
proto.acompanha.jobs.v1.UpdateJobRequest.prototype.getJobId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.jobs.v1.UpdateJobRequest} returns this
 */
proto.acompanha.jobs.v1.UpdateJobRequest.prototype.setJobId = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional int32 estimated_duration_minutes = 5;
 * @return {number}
 */
proto.acompanha.jobs.v1.UpdateJobRequest.prototype.getEstimatedDurationMinutes = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.acompanha.jobs.v1.UpdateJobRequest} returns this
 */
proto.acompanha.jobs.v1.UpdateJobRequest.prototype.setEstimatedDurationMinutes = function(value) {
  return jspb.Message.setField(this, 5, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.acompanha.jobs.v1.UpdateJobRequest} returns this
 */
proto.acompanha.jobs.v1.UpdateJobRequest.prototype.clearEstimatedDurationMinutes = function() {
  return jspb.Message.setField(this, 5, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.acompanha.jobs.v1.UpdateJobRequest.prototype.hasEstimatedDurationMinutes = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional int32 estimated_filament_consumption_grams = 6;
 * @return {number}
 */
proto.acompanha.jobs.v1.UpdateJobRequest.prototype.getEstimatedFilamentConsumptionGrams = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.acompanha.jobs.v1.UpdateJobRequest} returns this
 */
proto.acompanha.jobs.v1.UpdateJobRequest.prototype.setEstimatedFilamentConsumptionGrams = function(value) {
  return jspb.Message.setField(this, 6, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.acompanha.jobs.v1.UpdateJobRequest} returns this
 */
proto.acompanha.jobs.v1.UpdateJobRequest.prototype.clearEstimatedFilamentConsumptionGrams = function() {
  return jspb.Message.setField(this, 6, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.acompanha.jobs.v1.UpdateJobRequest.prototype.hasEstimatedFilamentConsumptionGrams = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional google.protobuf.Timestamp started_at = 7;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.acompanha.jobs.v1.UpdateJobRequest.prototype.getStartedAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 7));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.acompanha.jobs.v1.UpdateJobRequest} returns this
*/
proto.acompanha.jobs.v1.UpdateJobRequest.prototype.setStartedAt = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.acompanha.jobs.v1.UpdateJobRequest} returns this
 */
proto.acompanha.jobs.v1.UpdateJobRequest.prototype.clearStartedAt = function() {
  return this.setStartedAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.acompanha.jobs.v1.UpdateJobRequest.prototype.hasStartedAt = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional google.protobuf.Timestamp finished_at = 8;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.acompanha.jobs.v1.UpdateJobRequest.prototype.getFinishedAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 8));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.acompanha.jobs.v1.UpdateJobRequest} returns this
*/
proto.acompanha.jobs.v1.UpdateJobRequest.prototype.setFinishedAt = function(value) {
  return jspb.Message.setWrapperField(this, 8, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.acompanha.jobs.v1.UpdateJobRequest} returns this
 */
proto.acompanha.jobs.v1.UpdateJobRequest.prototype.clearFinishedAt = function() {
  return this.setFinishedAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.acompanha.jobs.v1.UpdateJobRequest.prototype.hasFinishedAt = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional string status = 9;
 * @return {string}
 */
proto.acompanha.jobs.v1.UpdateJobRequest.prototype.getStatus = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.jobs.v1.UpdateJobRequest} returns this
 */
proto.acompanha.jobs.v1.UpdateJobRequest.prototype.setStatus = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional string status_reason = 10;
 * @return {string}
 */
proto.acompanha.jobs.v1.UpdateJobRequest.prototype.getStatusReason = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.jobs.v1.UpdateJobRequest} returns this
 */
proto.acompanha.jobs.v1.UpdateJobRequest.prototype.setStatusReason = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * optional int32 object_count = 11;
 * @return {number}
 */
proto.acompanha.jobs.v1.UpdateJobRequest.prototype.getObjectCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 11, 0));
};


/**
 * @param {number} value
 * @return {!proto.acompanha.jobs.v1.UpdateJobRequest} returns this
 */
proto.acompanha.jobs.v1.UpdateJobRequest.prototype.setObjectCount = function(value) {
  return jspb.Message.setField(this, 11, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.acompanha.jobs.v1.UpdateJobRequest} returns this
 */
proto.acompanha.jobs.v1.UpdateJobRequest.prototype.clearObjectCount = function() {
  return jspb.Message.setField(this, 11, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.acompanha.jobs.v1.UpdateJobRequest.prototype.hasObjectCount = function() {
  return jspb.Message.getField(this, 11) != null;
};


/**
 * optional int32 printed_count = 12;
 * @return {number}
 */
proto.acompanha.jobs.v1.UpdateJobRequest.prototype.getPrintedCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 12, 0));
};


/**
 * @param {number} value
 * @return {!proto.acompanha.jobs.v1.UpdateJobRequest} returns this
 */
proto.acompanha.jobs.v1.UpdateJobRequest.prototype.setPrintedCount = function(value) {
  return jspb.Message.setField(this, 12, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.acompanha.jobs.v1.UpdateJobRequest} returns this
 */
proto.acompanha.jobs.v1.UpdateJobRequest.prototype.clearPrintedCount = function() {
  return jspb.Message.setField(this, 12, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.acompanha.jobs.v1.UpdateJobRequest.prototype.hasPrintedCount = function() {
  return jspb.Message.getField(this, 12) != null;
};


/**
 * repeated JobFilament filaments = 13;
 * @return {!Array<!proto.acompanha.jobs.v1.JobFilament>}
 */
proto.acompanha.jobs.v1.UpdateJobRequest.prototype.getFilamentsList = function() {
  return /** @type{!Array<!proto.acompanha.jobs.v1.JobFilament>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.acompanha.jobs.v1.JobFilament, 13));
};


/**
 * @param {!Array<!proto.acompanha.jobs.v1.JobFilament>} value
 * @return {!proto.acompanha.jobs.v1.UpdateJobRequest} returns this
*/
proto.acompanha.jobs.v1.UpdateJobRequest.prototype.setFilamentsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 13, value);
};


/**
 * @param {!proto.acompanha.jobs.v1.JobFilament=} opt_value
 * @param {number=} opt_index
 * @return {!proto.acompanha.jobs.v1.JobFilament}
 */
proto.acompanha.jobs.v1.UpdateJobRequest.prototype.addFilaments = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 13, opt_value, proto.acompanha.jobs.v1.JobFilament, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.acompanha.jobs.v1.UpdateJobRequest} returns this
 */
proto.acompanha.jobs.v1.UpdateJobRequest.prototype.clearFilamentsList = function() {
  return this.setFilamentsList([]);
};


/**
 * optional string metadata_json = 14;
 * @return {string}
 */
proto.acompanha.jobs.v1.UpdateJobRequest.prototype.getMetadataJson = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 14, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.jobs.v1.UpdateJobRequest} returns this
 */
proto.acompanha.jobs.v1.UpdateJobRequest.prototype.setMetadataJson = function(value) {
  return jspb.Message.setProto3StringField(this, 14, value);
};


/**
 * optional int32 actual_filament_consumption_grams = 15;
 * @return {number}
 */
proto.acompanha.jobs.v1.UpdateJobRequest.prototype.getActualFilamentConsumptionGrams = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 15, 0));
};


/**
 * @param {number} value
 * @return {!proto.acompanha.jobs.v1.UpdateJobRequest} returns this
 */
proto.acompanha.jobs.v1.UpdateJobRequest.prototype.setActualFilamentConsumptionGrams = function(value) {
  return jspb.Message.setField(this, 15, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.acompanha.jobs.v1.UpdateJobRequest} returns this
 */
proto.acompanha.jobs.v1.UpdateJobRequest.prototype.clearActualFilamentConsumptionGrams = function() {
  return jspb.Message.setField(this, 15, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.acompanha.jobs.v1.UpdateJobRequest.prototype.hasActualFilamentConsumptionGrams = function() {
  return jspb.Message.getField(this, 15) != null;
};


/**
 * optional bool filaments_provided = 16;
 * @return {boolean}
 */
proto.acompanha.jobs.v1.UpdateJobRequest.prototype.getFilamentsProvided = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 16, false));
};


/**
 * @param {boolean} value
 * @return {!proto.acompanha.jobs.v1.UpdateJobRequest} returns this
 */
proto.acompanha.jobs.v1.UpdateJobRequest.prototype.setFilamentsProvided = function(value) {
  return jspb.Message.setProto3BooleanField(this, 16, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.acompanha.jobs.v1.UpdateJobResponse.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.jobs.v1.UpdateJobResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.jobs.v1.UpdateJobResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.jobs.v1.UpdateJobResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.jobs.v1.UpdateJobResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
success: jspb.Message.getBooleanFieldWithDefault(msg, 1, false),
data: (f = msg.getData()) && proto.acompanha.jobs.v1.Job.toObject(includeInstance, f),
warningsList: (f = jspb.Message.getRepeatedField(msg, 3)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.jobs.v1.UpdateJobResponse}
 */
proto.acompanha.jobs.v1.UpdateJobResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.jobs.v1.UpdateJobResponse;
  return proto.acompanha.jobs.v1.UpdateJobResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.jobs.v1.UpdateJobResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.jobs.v1.UpdateJobResponse}
 */
proto.acompanha.jobs.v1.UpdateJobResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSuccess(value);
      break;
    case 2:
      var value = new proto.acompanha.jobs.v1.Job;
      reader.readMessage(value,proto.acompanha.jobs.v1.Job.deserializeBinaryFromReader);
      msg.setData(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.addWarnings(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.jobs.v1.UpdateJobResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.jobs.v1.UpdateJobResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.jobs.v1.UpdateJobResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.jobs.v1.UpdateJobResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSuccess();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
  f = message.getData();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.acompanha.jobs.v1.Job.serializeBinaryToWriter
    );
  }
  f = message.getWarningsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      3,
      f
    );
  }
};


/**
 * optional bool success = 1;
 * @return {boolean}
 */
proto.acompanha.jobs.v1.UpdateJobResponse.prototype.getSuccess = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.acompanha.jobs.v1.UpdateJobResponse} returns this
 */
proto.acompanha.jobs.v1.UpdateJobResponse.prototype.setSuccess = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};


/**
 * optional Job data = 2;
 * @return {?proto.acompanha.jobs.v1.Job}
 */
proto.acompanha.jobs.v1.UpdateJobResponse.prototype.getData = function() {
  return /** @type{?proto.acompanha.jobs.v1.Job} */ (
    jspb.Message.getWrapperField(this, proto.acompanha.jobs.v1.Job, 2));
};


/**
 * @param {?proto.acompanha.jobs.v1.Job|undefined} value
 * @return {!proto.acompanha.jobs.v1.UpdateJobResponse} returns this
*/
proto.acompanha.jobs.v1.UpdateJobResponse.prototype.setData = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.acompanha.jobs.v1.UpdateJobResponse} returns this
 */
proto.acompanha.jobs.v1.UpdateJobResponse.prototype.clearData = function() {
  return this.setData(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.acompanha.jobs.v1.UpdateJobResponse.prototype.hasData = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * repeated string warnings = 3;
 * @return {!Array<string>}
 */
proto.acompanha.jobs.v1.UpdateJobResponse.prototype.getWarningsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 3));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.acompanha.jobs.v1.UpdateJobResponse} returns this
 */
proto.acompanha.jobs.v1.UpdateJobResponse.prototype.setWarningsList = function(value) {
  return jspb.Message.setField(this, 3, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.acompanha.jobs.v1.UpdateJobResponse} returns this
 */
proto.acompanha.jobs.v1.UpdateJobResponse.prototype.addWarnings = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 3, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.acompanha.jobs.v1.UpdateJobResponse} returns this
 */
proto.acompanha.jobs.v1.UpdateJobResponse.prototype.clearWarningsList = function() {
  return this.setWarningsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.jobs.v1.DeleteJobRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.jobs.v1.DeleteJobRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.jobs.v1.DeleteJobRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.jobs.v1.DeleteJobRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
uuid: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.jobs.v1.DeleteJobRequest}
 */
proto.acompanha.jobs.v1.DeleteJobRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.jobs.v1.DeleteJobRequest;
  return proto.acompanha.jobs.v1.DeleteJobRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.jobs.v1.DeleteJobRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.jobs.v1.DeleteJobRequest}
 */
proto.acompanha.jobs.v1.DeleteJobRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUuid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.jobs.v1.DeleteJobRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.jobs.v1.DeleteJobRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.jobs.v1.DeleteJobRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.jobs.v1.DeleteJobRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUuid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string uuid = 1;
 * @return {string}
 */
proto.acompanha.jobs.v1.DeleteJobRequest.prototype.getUuid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.jobs.v1.DeleteJobRequest} returns this
 */
proto.acompanha.jobs.v1.DeleteJobRequest.prototype.setUuid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.jobs.v1.PrinterStatsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.jobs.v1.PrinterStatsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.jobs.v1.PrinterStatsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.jobs.v1.PrinterStatsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
q: jspb.Message.getFieldWithDefault(msg, 1, ""),
printerUuid: jspb.Message.getFieldWithDefault(msg, 2, ""),
status: jspb.Message.getFieldWithDefault(msg, 3, ""),
finishedFrom: (f = msg.getFinishedFrom()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
finishedTo: (f = msg.getFinishedTo()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.jobs.v1.PrinterStatsRequest}
 */
proto.acompanha.jobs.v1.PrinterStatsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.jobs.v1.PrinterStatsRequest;
  return proto.acompanha.jobs.v1.PrinterStatsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.jobs.v1.PrinterStatsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.jobs.v1.PrinterStatsRequest}
 */
proto.acompanha.jobs.v1.PrinterStatsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setQ(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setPrinterUuid(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setStatus(value);
      break;
    case 4:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setFinishedFrom(value);
      break;
    case 5:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setFinishedTo(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.jobs.v1.PrinterStatsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.jobs.v1.PrinterStatsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.jobs.v1.PrinterStatsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.jobs.v1.PrinterStatsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getQ();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getPrinterUuid();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getStatus();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getFinishedFrom();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getFinishedTo();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
};


/**
 * optional string q = 1;
 * @return {string}
 */
proto.acompanha.jobs.v1.PrinterStatsRequest.prototype.getQ = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.jobs.v1.PrinterStatsRequest} returns this
 */
proto.acompanha.jobs.v1.PrinterStatsRequest.prototype.setQ = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string printer_uuid = 2;
 * @return {string}
 */
proto.acompanha.jobs.v1.PrinterStatsRequest.prototype.getPrinterUuid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.jobs.v1.PrinterStatsRequest} returns this
 */
proto.acompanha.jobs.v1.PrinterStatsRequest.prototype.setPrinterUuid = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string status = 3;
 * @return {string}
 */
proto.acompanha.jobs.v1.PrinterStatsRequest.prototype.getStatus = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.jobs.v1.PrinterStatsRequest} returns this
 */
proto.acompanha.jobs.v1.PrinterStatsRequest.prototype.setStatus = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional google.protobuf.Timestamp finished_from = 4;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.acompanha.jobs.v1.PrinterStatsRequest.prototype.getFinishedFrom = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 4));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.acompanha.jobs.v1.PrinterStatsRequest} returns this
*/
proto.acompanha.jobs.v1.PrinterStatsRequest.prototype.setFinishedFrom = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.acompanha.jobs.v1.PrinterStatsRequest} returns this
 */
proto.acompanha.jobs.v1.PrinterStatsRequest.prototype.clearFinishedFrom = function() {
  return this.setFinishedFrom(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.acompanha.jobs.v1.PrinterStatsRequest.prototype.hasFinishedFrom = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional google.protobuf.Timestamp finished_to = 5;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.acompanha.jobs.v1.PrinterStatsRequest.prototype.getFinishedTo = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 5));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.acompanha.jobs.v1.PrinterStatsRequest} returns this
*/
proto.acompanha.jobs.v1.PrinterStatsRequest.prototype.setFinishedTo = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.acompanha.jobs.v1.PrinterStatsRequest} returns this
 */
proto.acompanha.jobs.v1.PrinterStatsRequest.prototype.clearFinishedTo = function() {
  return this.setFinishedTo(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.acompanha.jobs.v1.PrinterStatsRequest.prototype.hasFinishedTo = function() {
  return jspb.Message.getField(this, 5) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.acompanha.jobs.v1.PrinterStatsResponse.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.jobs.v1.PrinterStatsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.jobs.v1.PrinterStatsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.jobs.v1.PrinterStatsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.jobs.v1.PrinterStatsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
success: jspb.Message.getBooleanFieldWithDefault(msg, 1, false),
printersList: jspb.Message.toObjectList(msg.getPrintersList(),
    proto.acompanha.jobs.v1.PrinterStat.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.jobs.v1.PrinterStatsResponse}
 */
proto.acompanha.jobs.v1.PrinterStatsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.jobs.v1.PrinterStatsResponse;
  return proto.acompanha.jobs.v1.PrinterStatsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.jobs.v1.PrinterStatsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.jobs.v1.PrinterStatsResponse}
 */
proto.acompanha.jobs.v1.PrinterStatsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSuccess(value);
      break;
    case 2:
      var value = new proto.acompanha.jobs.v1.PrinterStat;
      reader.readMessage(value,proto.acompanha.jobs.v1.PrinterStat.deserializeBinaryFromReader);
      msg.addPrinters(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.jobs.v1.PrinterStatsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.jobs.v1.PrinterStatsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.jobs.v1.PrinterStatsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.jobs.v1.PrinterStatsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSuccess();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
  f = message.getPrintersList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.acompanha.jobs.v1.PrinterStat.serializeBinaryToWriter
    );
  }
};


/**
 * optional bool success = 1;
 * @return {boolean}
 */
proto.acompanha.jobs.v1.PrinterStatsResponse.prototype.getSuccess = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.acompanha.jobs.v1.PrinterStatsResponse} returns this
 */
proto.acompanha.jobs.v1.PrinterStatsResponse.prototype.setSuccess = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};


/**
 * repeated PrinterStat printers = 2;
 * @return {!Array<!proto.acompanha.jobs.v1.PrinterStat>}
 */
proto.acompanha.jobs.v1.PrinterStatsResponse.prototype.getPrintersList = function() {
  return /** @type{!Array<!proto.acompanha.jobs.v1.PrinterStat>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.acompanha.jobs.v1.PrinterStat, 2));
};


/**
 * @param {!Array<!proto.acompanha.jobs.v1.PrinterStat>} value
 * @return {!proto.acompanha.jobs.v1.PrinterStatsResponse} returns this
*/
proto.acompanha.jobs.v1.PrinterStatsResponse.prototype.setPrintersList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.acompanha.jobs.v1.PrinterStat=} opt_value
 * @param {number=} opt_index
 * @return {!proto.acompanha.jobs.v1.PrinterStat}
 */
proto.acompanha.jobs.v1.PrinterStatsResponse.prototype.addPrinters = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.acompanha.jobs.v1.PrinterStat, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.acompanha.jobs.v1.PrinterStatsResponse} returns this
 */
proto.acompanha.jobs.v1.PrinterStatsResponse.prototype.clearPrintersList = function() {
  return this.setPrintersList([]);
};


goog.object.extend(exports, proto.acompanha.jobs.v1);
